import { JsonPrice, Price } from "./types";
import { convertToRoundPrice } from "./Utils";

const extractNumericValue = (label: string) => parseFloat(label);

export const generateInternalProductId = (internalIdPrefix: string, allPrices: JsonPrice[][]): string => {
    const parts = [`${internalIdPrefix}:`];

    allPrices
        .flat()
        .sort((a, b) => extractNumericValue(a.label) - extractNumericValue(b.label))
        .forEach((price) => {
            parts.push(`${price.label} voor ${convertToRoundPrice(price.price)} -`);
        });

    return parts.join(" ");
};

export const findExistingPrice = (prices: Price[], internalProductId: string): Price | undefined => {
    return prices.find((price) => {
        return price.internal_product_id === internalProductId.substring(0, internalProductId.length - 3);
    });
};

export const findExistingPriceByKassaCode = (prices: Price[], kassaCode: string): Price | undefined => {
    for (const price of prices) {
        console.log("PPP", price);
        console.log("INT P ID", price.internal_product_id);
    }
    return prices.find((price) => {
        return price.internal_product_id === kassaCode;
    });
};

export const parseInternalProductId = (id: string) => {
    const match = id.match(/^(\d+):(.*)$/);

    if (!match) {
        return {
            prefix: "",
            suffix: id,
        };
    }

    return {
        prefix: match[1], // "000", "419", "1040"
        suffix: match[2].trim(), // everything after ":"
    };
};

export const buildInternalProductId = (prefix: string, suffix: string) => {
    return `${prefix}:${suffix ? " " + suffix : ""}`;
};
